<div *transloco="let t" class="flex flex-col overflow-hidden lg:h-available p-4 lg:p-12 gap-8">

  <!-- Header -->
  <div class="font-thin text-3xl">{{ t('orders.myOrders') }}</div>

  @if (orders.isLoading()) {
    <div class="flex items-center justify-center h-64 text-gray-400 text-lg font-thin">{{ t('orders.loading') }}</div>
  } @else if (!orders.value()?.data?.length) {
    <div class="flex flex-col items-center justify-center h-64 gap-4 text-gray-400">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="w-16 h-16 opacity-30">
        <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
      </svg>
      <span class="font-thin text-xl">{{ t('orders.empty') }}</span>
      <a routerLink="/artworks" class="text-sm underline text-gray-500 hover:text-black">{{ t('orders.discover') }}</a>
    </div>
  } @else {
    <div class="flex flex-col gap-6">
      @for (order of orders.value()!.data; track order.id) {
        <div class="rounded-2xl border border-gray-100 bg-white shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden">

          <!-- Header ordine -->
          <div class="flex flex-wrap items-center justify-between gap-3 px-5 py-4 border-b border-gray-100 bg-gray-50">
            <div class="flex items-center gap-3">
              <span class="text-sm text-gray-400">{{ t('orders.order') }} <span class="font-semibold text-black">#{{ order.id }}</span></span>
              <span class="text-xs font-semibold px-2 py-1 rounded-full" [class]="statusClass(order.status)">
                {{ t('orders.status.' + order.status) }}
              </span>
            </div>
            <div class="flex items-center gap-4 text-sm text-gray-400">
              <span>{{ order.createdAt | date : 'dd MMM yyyy' }}</span>
              <span class="font-semibold text-black text-base">{{ order.total | currency : 'EUR' : '' : '1.2-2' }} €</span>
            </div>
          </div>

          <!-- Righe opere -->
          <div class="divide-y divide-gray-50">
            @for (row of order.rows; track row.id) {
              <div class="flex items-center gap-4 px-5 py-4">
                <a [routerLink]="['/artworks', row.artwork.id]" class="shrink-0 w-16 h-16 rounded-xl overflow-hidden bg-gray-100 flex items-center justify-center">
                  @if (row.artwork.mainAttachment) {
                    <img [src]="row.artwork.mainAttachment.url" class="w-full h-full object-cover" />
                  }
                </a>
                <div class="flex-1 min-w-0">
                  <a [routerLink]="['/artworks', row.artwork.id]" class="font-light text-lg hover:underline truncate block">{{ row.artwork.name }}</a>
                  <div class="text-sm text-gray-400">{{ t('orders.qty') }}: {{ row.qty }}</div>
                </div>
                <div class="text-right shrink-0">
                  <div class="font-semibold">{{ (row.price * row.qty) | currency : 'EUR' : '' : '1.2-2' }} €</div>
                  @if (row.qty > 1) {
                    <div class="text-xs text-gray-400">{{ row.price | currency : 'EUR' : '' : '1.2-2' }} € / {{ t('orders.unit') }}</div>
                  }
                </div>
              </div>
            }
          </div>

          <!-- Indirizzo di spedizione -->
          @if (order.address) {
            <div class="px-5 py-3 border-t border-gray-100 text-sm text-gray-500">
              <div class="font-medium text-gray-700 mb-1">{{ t('orders.shippingAddress') }}</div>
              <div>{{ $any(order.address).name }} {{ $any(order.address).surname }}</div>
              <div>{{ $any(order.address).street }} {{ $any(order.address).streetNumber }}, {{ $any(order.address).city }} {{ $any(order.address).zipCode }}</div>
              <div>{{ $any(order.address).country }}</div>
            </div>
          }

          <!-- Footer spedizione -->
          @if (order.shippingCosts > 0) {
            <div class="flex justify-between items-center px-5 py-3 border-t border-gray-100 text-sm text-gray-500">
              <span>{{ t('orders.shipping') }}</span>
              <span>{{ order.shippingCosts | currency : 'EUR' : '' : '1.2-2' }} €</span>
            </div>
          }

        </div>
      }
    </div>
  }

</div>
